<template>
    <FormSection title="Comments" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <section class="d-flex flex-column px-3 py-2">
                <TemplateInput
                    :templates="referralOptions.template"
                    :application="application"
                    :accountId="accountId"
                    v-on:resultUpdated="(e:any) => onCommentSelect(e)"
                    :result="referral.Clinical.Comments"
                />
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ClinicalComments.ts"></script>
